<section class="info-dialog" [ngClass]="'info-dialog--' + dialogType">
  <div class="info-dialog__icon">
    <mat-icon>{{ icon }}</mat-icon>
  </div>

  <h2>{{ data.title }}</h2>

  @if (data.message) {
    <p>
      {{ data.message }}
    </p>
  }

  @if (data.messages?.length) {
    <ul>
      @for (message of data.messages; track message) {
        <li>
          {{ message }}
        </li>
      }
    </ul>
  }

  @if (data.imageSrc) {
    <figure class="info-dialog__image">
      <img [src]="data.imageSrc" [alt]="data.imageAlt || data.title">
    </figure>
  }

  <div class="info-dialog__actions">
    @if (data.showCancelButton) {
      <button
        type="button"
        class="info-dialog__action info-dialog__action--secondary"
        (click)="cancelar()">
        {{ data.cancelText || 'Cancelar' }}
      </button>
    }

    <button
      type="button"
      class="info-dialog__action info-dialog__action--primary"
      (click)="confirmar()">
      {{ data.confirmText || data.actionText || 'Entendido' }}
    </button>
  </div>
</section>